import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../../core/lib/api";
import { useToastStore } from "../../../core/stores/toast";
import { PageHeader } from "../../../core/components/ui/page-header";
import { Button } from "../../../core/components/ui/button";
import { Modal } from "../../../core/components/ui/modal";
import { Field, Input } from "../../../core/components/ui/input";
import { Icon } from "../../../core/components/ui/icon";
import { formatDateTime } from "../../../core/lib/format";
import { useTenantStore } from "../stores/tenant";

export function TenantsList() {
  const { available, load, setTenant } = useTenantStore();
  const push = useToastStore((s) => s.push);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [timezone, setTimezone] = useState("America/Montreal");
  const [busy, setBusy] = useState(false);

  const create = async () => {
    if (busy || !name.trim()) return;
    setBusy(true);
    try {
      const t = await api<{ id: string }>("/api/tenants", { method: "POST", body: JSON.stringify({ name, timezone }) });
      push("success", "Établissement créé");
      setOpen(false);
      setName("");
      await load();
      setTenant(t.id);
    } catch {
      push("danger", "Création impossible");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page">
      <PageHeader
        title="Établissements"
        subtitle="Chaque établissement a ses données et ses membres."
        actions={
          <Button variant="primary" icon={<Icon name="plus" size={16} />} onClick={() => setOpen(true)}>
            Nouvel établissement
          </Button>
        }
      />

      {available.length === 0 ? (
        <div className="empty">Aucun établissement. Créez le premier.</div>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Fuseau horaire</th>
              <th>Créé le</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {available.map((t) => (
              <tr key={t.id}>
                <td>{t.name}</td>
                <td>{t.timezone}</td>
                <td>{formatDateTime(t.createdAt, { dateStyle: "medium" })}</td>
                <td className="table__actions">
                  <Link to={`/etablissements/${t.id}`}>Configurer</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <Modal
        open={open}
        title="Nouvel établissement"
        onClose={() => setOpen(false)}
        footer={
          <>
            <Button variant="ghost" onClick={() => setOpen(false)}>
              Annuler
            </Button>
            <Button variant="primary" onClick={create} disabled={busy || !name.trim()}>
              Créer
            </Button>
          </>
        }
      >
        <div className="form-grid">
          <Field label="Nom">
            <Input value={name} onChange={(e) => setName(e.target.value)} autoFocus />
          </Field>
          <Field label="Fuseau horaire" hint="Identifiant IANA.">
            <Input value={timezone} onChange={(e) => setTimezone(e.target.value)} />
          </Field>
        </div>
      </Modal>
    </div>
  );
}
